import HeaderButton from '@molecules/HeaderButton';
import React from 'react';

import { Menu01Icon } from '@hugeicons/core-free-icons';
import type { DrawerNavigationProp } from '@react-navigation/drawer';

const HeaderDrawerButton = (
  <HeaderButton<DrawerNavigationProp<never>>
    icon={Menu01Icon}
    onPress={(_, navigation) => {
      navigation.openDrawer();
    }}
  />
);

export default HeaderDrawerButton;
